import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    ElementRef,
    Inject,
    OnDestroy,
    ViewChild
} from '@angular/core';
import {
    MAT_LEGACY_SNACK_BAR_DATA as MAT_SNACK_BAR_DATA,
    MatLegacySnackBarRef as MatSnackBarRef
} from '@angular/material/legacy-snack-bar';
import { Toast, ToastAction, ToastActionType } from './toast.service';
import { Observable, Subject } from 'rxjs';
import { KeyValue } from '@angular/common';

@Component({
    template: `
        <svg
            class="toast-countdown"
            xmlns="http://www.w3.org/2000/svg"
            [style.--path-length]="pathLength"
            [style.--path-length-negative]="-pathLength"
            [style.--duration]="duration"
        >
            <rect #rectRef />
        </svg>
        <div class="toast-content">
            <div>
                <strong *ngIf="data.title" class="me-1">{{ data.title }}</strong>
                {{ data.message }}
            </div>
            <footer *ngIf="data.actions as actions">
                <button
                    *ngFor="let action of actions | keyvalue : actionsOrder"
                    type="button"
                    class="btn btn-sm"
                    [ngClass]="'btn-' + action.key"
                    (click)="triggerAction(action.key, $event)"
                >
                    {{ action.value }}
                </button>
            </footer>
        </div>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SbToastComponent implements OnDestroy {
    @ViewChild('rectRef')
    set rectRef(value: ElementRef<SVGRectElement>) {
        this.pathLength = value.nativeElement.getTotalLength();
        this._cdr.detectChanges();
    }
    get $action(): Observable<ToastAction> {
        return this._$action.asObservable();
    }

    pathLength: number;
    duration: string;

    // order actions and place primary action last (to the right)
    actionsOrder = (a: KeyValue<ToastActionType, string>): number => {
        return a.key === 'primary' ? 1 : -1;
    };
    constructor(
        @Inject(MAT_SNACK_BAR_DATA) public data: Toast,
        private _snackRef: MatSnackBarRef<SbToastComponent>,
        private _cdr: ChangeDetectorRef
    ) {
        this.duration =
            this._snackRef.containerInstance?.snackBarConfig?.duration + 2000 + 'ms';
    }
    private _$action: Subject<ToastAction> = new Subject();

    triggerAction(name: ToastActionType, event: MouseEvent) {
        this._$action.next({ name, event });
        this._snackRef.dismissWithAction();
    }

    ngOnDestroy(): void {
        // unsubscribe active subscribers by completing observable
        this._$action.complete();
    }
}
